<template>
  <div class="card" v-if="hasAccess">
    <div class="card-header">
      <div class="row mb-2">
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>سفارش دهنده</span>
            </div>
          </div>
          <input
            v-if="isRecivere"
            disabled
            v-model="orderModel.receiverName"
            type="text"
            v-bind:class="{ 'hover-pointer': mode!=='view' }"
            class="form-control"
            readonly
          >
          <input
            v-else
            v-model="orderModel.receiverName"
            type="text"
            v-bind:class="{ 'hover-pointer': mode!=='view' }"
            class="form-control"
            @click="openCompanyModal('receiver')"
            placeholder="کلیک کنید"
            readonly
            :disabled="isRecivere"
          >
        </div>
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>تامین کننده</span>
            </div>
          </div>
          <!--          <input v-model="server.name" type="text" class="form-control">-->
          <input
            v-if="isServer"
            disabled
            readonly
            v-bind:class="{ 'hover-pointer': mode!=='view' }"
            v-model="orderModel.serveName"
            type="text"
            class="form-control"
          >
          <input
            v-else
            readonly
            placeholder="کلیک کنید"
            v-bind:class="{ 'hover-pointer': mode!=='view' }"
            v-model="orderModel.serveName"
            type="text"
            class="form-control"
            @click="openCompanyModal('serve')"
            :disabled="isServer"
          >
        </div>
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>تاریخ سفارش</span>
            </div>
          </div>
          <input
            v-if="mode==='create'"
            :value="currentDate"
            type="text"
            class="form-control"
            readonly
          >
          <input v-else :value="orderModel.date" type="text" class="form-control" readonly>
        </div>
        <div class="col-sm-2"></div>
        <div class="col-sm-1 d-flex justify-content-end">
          <button v-if="mode==='view'" class="btn btn-info mr-3" @click="onPrintClicked(orderModel.id)"><i class="fa fa-print"></i></button>

          <button type="button" class="close" aria-label="Close" @click="goBack">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="input-group col-9">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات و جزییات سفارش</span>
            </div>
          </div>
          <input
            :readonly="mode==='view'"
            v-model="orderModel.description"
            type="text"
            class="form-control"
          >
        </div>
        <div class="input-group col-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>کد سفارش</span>
            </div>
          </div>
          <input
            :readonly="mode==='view'"
            v-model="orderModel.code"
            type="text"
            placeholder="بصورت اتوماتیک صادر میشود"
            class="form-control"
          >
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <vs-table
            v-if="show"
            :params="params"
            :options="options"
            @onCreateHeaderActionClicked="openProductModal"
          ></vs-table>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mb-2">
        <div class="input-group col-sm-3"></div>
        <div class="input-group col-sm-3"></div>
        <div class="input-group col-sm-3"></div>
        <div class="col-sm-2">
          <button v-if="mode==='create'||mode==='edit'" class="btn btn-success" @click="submit">
            <span v-if="mode==='create'">ثبت سفارش</span>
            <span v-if="mode==='edit'">ویرایش سفارش</span>
          </button>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="openProductDetailModal"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowSelect="selectProduct"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>

    </b-modal>
    <b-modal
      ref="selectCompany"
      title="انتخاب شرکت"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="onSelectCompany"
    >
      <order-selected-company
        :missed-tab="missedTab"
        @selectCompany="selectCompany"
        @onRowDoubleClicked="onCompanyDoubleClicked"
      ></order-selected-company>
    </b-modal>
    <div ref="container"></div>
  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import EventBus from "../bus.js";
  import Products from "./Products.vue";
  import Moment from "moment-jalali";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import BaseService from "../_framework/api/BaseService.js";
  import BdSelectCompanyModal from "../components/BDSelectCompanyModal.vue";
  import BdProductOrderModal from "../components/BDProductOrderModal.vue";
  import BDProductPasteModal from "../components/BDProductPasteModal.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Utils from "../_framework/utils/Utils.js";
  import OrderSelectedCompany from "../components/OrderSelectedCompany";

  export default {
    name: "orderDetail",
    components: {
      OrderSelectedCompany,
      VsTable,
      Moment,
      datePicker: DatePicker,
      VsSelect,
      BdSelectCompanyModal,
      BdProductOrderModal,
      Products
    },
    data() {
      return {
        hasAccess: true,
        access: {},
        show: true,
        orderDate: null,
        orderModel: {
          serveName: "",
          receiverName: "",
          orders: [],
          date: null
        },
        rowsPrice: 0,
        selectedCompany: {},
        selectedProduct: {},
        productOrderModel: {},
        missedTab: "",
        selectModalMode: "",
        currentDate: Moment().format("jYYYY/jMM/jDD"),
        params: {
          entity: "voucher",
          list: [],
          headers: {
            productId: {
              title: "ردیف",
              type: "number",
              rowAlignment: "center",
            },
              productCode: {
              title: "کد کالا",
              type: "text",
              rowAlignment: "center"
            },
            productName: {
              title: "نام کالا",
              type: "text",
              rowAlignment: "center"
            },
            number: {
              title: "تعداد",
              type: "number",
              rowAlignment: "center"
            },
            unit: {
              title: "واحد",
              type: "text",
              rowAlignment: "center"
            },
            deliveryDate: {
              title: "تاریخ تحویل",
              type: "text",
              rowAlignment: "center",
              formatGregorianDateToJalaali: true
            }
          },
          showPaste: true,
        },
        options: {
          dataSourceType: "store",
          hasActions: true,
          onRowClicked: row => {
          },
          hasActionsInHeader: true,
          clickableRows: true,
          onCreateHeaderActionClicked: true,
          onEditClicked: (row, context) => {
            this.productOrderModel = row;
            this.productOrderModel.mode = "edit";
            this.openProductDetailModal();
          },

          onPasteClicked: (row, context) => {
            this.productPasteModel = row;
            this.productPasteModel.mode = "Paste";
            this.openProductPasteModal();
          },
          onRowDoubleClicked: row => {
            this.productOrderModel = row;
            this.productOrderModel.mode = "view";
            this.openProductDetailModal();
          },
          beforeDeleteEntity: input => {
            this.deleteOrdersTableRow(input.id);
            return null;
          }
        },

        isServer: false,
        isRecivere: false,

      };
    },
    methods: {
      onPrintClicked(id) {
        this.$router.push(
          {
            name: "پرینت سفارش",
            params: {
              id: id,
              isBuyOrder:true
            }
          }
        );
      },
      deleteOrdersTableRow(id) {
        this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
        this.orderModel.orders = this.orderModel.orders.filter(o => {
          return o.id !== id;
        });
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 1);
      },

      goBack() {
        if(this.isServer ) {
          this.$router.push({name: "سفارشات مشتری"});
        }
        if(this.isRecivere) {
          this.$router.push({name:"سفارشات خرید-تامین"});
        }
        if(!this.isServer && !this.isRecivere) {
          this.$router.push({name: "سفارشات مشتری"});
        }
      },

      onCompanyDoubleClicked() {
        this.onSelectCompany();
        if (this.$refs && this.$refs.selectCompany) {
          this.$refs.selectCompany.hide();
        }
      },

      onSelectCompany() {
        const currentCompanyName = localStorage.getItem("company");
        const currentCompanyId = Number(localStorage.getItem("companyId"));
        const isCompany = this.selectedCompany.type === 'company';
        const companyId = this.selectedCompany.id;
        const companyName = isCompany ? this.selectedCompany.companyName : this.selectedCompany.outSourceName;

        if (this.selectModalMode === 'receiver') {
          this.orderModel.receiverName = companyName;
          this.orderModel.receiverOutSourceId = isCompany ? null : companyId;
          this.orderModel.receiverCompanyId = isCompany ? companyId : null;

          if (isCompany && companyId === currentCompanyId) {
            if (companyId === this.orderModel.serveCompanyId) {
              this.orderModel.serveName = "";
              this.orderModel.serveOutSourceId = null;
              this.orderModel.serveCompanyId = null;
            }
          } else {
            this.orderModel.serveName = currentCompanyName;
            this.orderModel.serveOutSourceId = null;
            this.orderModel.serveCompanyId = currentCompanyId;
          }
        } else {
          if (isCompany && companyId === currentCompanyId) {
            if (companyId === this.orderModel.receiverCompanyId) {
              this.orderModel.receiverName = "";
              this.orderModel.receiverOutSourceId = null;
              this.orderModel.receiverCompanyId = null;
            }
          } else {
            this.orderModel.receiverName = currentCompanyName;
            this.orderModel.receiverOutSourceId = null;
            this.orderModel.receiverCompanyId = currentCompanyId;
          }

          this.orderModel.serveName = companyName;
          this.orderModel.serveOutSourceId = isCompany ? null : companyId;
          this.orderModel.serveCompanyId = isCompany ? companyId : null;
        }
      },

      selectCompany(data) {
        this.selectedCompany = data;
        // console.log(data);
      },

      openCompanyModal(selectMode) {
        if (this.mode === "view") {
          return;
        }
        this.selectModalMode = selectMode;
        this.$refs.selectCompany.show();
      },

      selectProduct(prod) {
        this.selectedProduct = prod;
        // console.log(prod);
        this.productOrderModel = {};
        this.productOrderModel.productName = prod.productName;
        this.productOrderModel.productCode = prod.productCode;
        this.productOrderModel.productId = prod.id;
        this.productOrderModel.title1 = prod.title1;
        this.productOrderModel.title2 = prod.title2;
        this.productOrderModel.unit = prod.unit.unitValue;
        this.productOrderModel.unitId = prod.unit.id;
        this.productOrderModel.stock = prod.stock;
        this.productOrderModel.type = "Create";
      },

      changepvmData(pvmData) {
        this.productOrderModel = pvmData;
      },

      openProductDetailModal(prod) {
        this.$refs.modal.hide();
        let ComponentClass = Vue.extend(BdProductOrderModal);
        let pdModal = new ComponentClass({
          propsData: {
            model: this.productOrderModel
          }
        });
        pdModal.$mount();
        this.$refs.container.appendChild(pdModal.$el);
        setTimeout(() => {
          pdModal.openModal();
        }, 200);
        pdModal.$on("onProductOrderModalOk", mode => {
          if (mode === "create") {
            this.addOrderRow();
          } else if (mode === "update") {
            this.updateOrderRow();
          }
        });
      },
      openProductPasteModal(prod) {
        this.$refs.modal.hide();
        let ComponentClass = Vue.extend(BDProductPasteModal);
        let pdModal = new ComponentClass({
          propsData: {
            model: this.productPasteModel
          }
        });
        pdModal.$mount();
        this.$refs.container.appendChild(pdModal.$el);
        setTimeout(() => {
          pdModal.openModal();
        }, 200);
        pdModal.$on("onProductPasteModalOk", mode => {
          if (mode === "create") {
            this.addOrderRow();
          } else if (mode === "update") {
            this.updateOrderRow();
          }
        });
      },

      openProductModal() {
        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();
        if (this.$refs.productsContainer) {
          if (this.$refs.productsContainer.hasChildNodes()) {
            this.$refs.productsContainer.removeChild(
              this.$refs.productsContainer.childNodes[0]
            );
          }
          this.$refs.productsContainer.appendChild(_products.$el);
        }


        if (this.$refs && this.$refs.modal) {
          this.$refs.modal.show();
        }
        _products.$on("onRowSelect", row => {
          this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.openProductDetailModal(row);
        });
      },

      setDateFromDatePicker(date) {
        this.orderDate = date;
        this.orderModel.orderDate = date;
      },

      toggleStartDatePicker() {
        this.$refs.datePicker.togglePicker();
      },

      hideModal() {
        this.$refs.modal.hide();
      },

      addOrderRow(_data) {
        let data = _data || JSON.parse(JSON.stringify(this.productOrderModel));
        this.addOrderProducts(data);
      },

      updateOrderRow(_data) {
        let data = _data || JSON.parse(JSON.stringify(this.productOrderModel));
        this.updateOrderProducts(data);
      },

      addOrderProducts(data) {
        // console.log("data");
        // console.log(data);
        let number = data.number || data.unitVal;
        number = number * 1;
        this.orderModel.orders.push({
          productId: data.productId,
          unitId: data.unitId,
          productCode: data.productCode,
          unitVal: number,
          deliveryDate: data.deliveryDate,
          description: data.description
        });
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          productId: data.productId,
          unitId: data.unit ? data.unit.id : data.unitId,
          productName: data.productName,
          productCode: data.productCode,
          unit: data.unitName || data.unit,
          number: number,
          deliveryDate: data.deliveryDate,
          description: data.description
        });
        this.refreshOrderProductsTable();
      },

      updateOrderProducts(data) {
        // console.log(data);

        let number = data.number || data.unitVal;
        number = number * 1;
        this.orderModel.orders = this.orderModel.orders.map(om => {
          if (om.id === data.id) {
            om.productId = data.productId;
            om.productCode= data.productCode;
            om.unitId = data.unitId || data.unit.id;
            om.unitVal = number;
            om.deliveryDate = data.deliveryDate;
            om.description = data.description;
          }
          return om;
        });
      },

      refreshOrderProductsTable() {
        let id = 0;
        this.vsTableFeed.map(p => {
          id = id + 1;
          p.id = id;
        });
        id = 0;
        this.orderModel.orders.map(p => {
          id = id + 1;
          p.id = id;
        });
      },

      submit() {

        if (this.mode === "create") {
          this.orderModel.date = this.currentDate;
          new BaseService("orders").create(this.orderModel).then(rs => {
            this.goBack();
          });
        } else if (this.mode === "edit") {
          new BaseService("orders").update(this.orderModel).then(rs => {
            this.goBack();
          });
        }
      }
    },
    mounted() {
      EventBus.$on("selectTreeNode", data => {
        data.type = "company";
        this.selectedCompany = data;
        // console.log(data);
      });
    },

    beforeMount() {
      this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
      this.options.access = checkAccess(this.$route.path);
      this.hasAccess = !!this.options.access;
      if (this.$route.query._mode === "view") {
        this.options.hasActions = false;
        this.options.hasActionsInHeader = false;
      }
      if (this.$route.query.id && this.$route.query.id != 0) {
        new BaseService("orders").getById(this.$route.query.id).then(rs => {
          if (!rs.data) {
            this.$noty.error("شناسه سفارش نامعتبر است")
          }
          this.orderModel.id = rs.data.id;
          this.orderModel.date = rs.data.date;
          this.orderModel.code = rs.data.code;
          this.orderModel.description = rs.data.description;
          this.orderModel.receiverName = rs.data.receiverName;
          this.orderModel.receiverOutSourceId = rs.data.receiverOutSourceId;
          this.orderModel.receiverCompanyId = rs.data.receiverCompanyId;
          this.orderModel.serveName = rs.data.serveName;
          this.orderModel.serveOutSourceId = rs.data.serveOutSourceId;
          this.orderModel.serveCompanyId = rs.data.serveCompanyId;
          this.orderModel.orders = [];
          rs.data.orders.map(o => {
            this.addOrderRow(o);
          });
        });
      }
      // console.log(this.$route.query.type);
      if (this.$route.query.type == 1) {
        this.orderModel.serveCompanyId = Number(localStorage.getItem("companyId"));
        this.orderModel.serveName = localStorage.getItem("company");
        this.isServer = true;
        // localStorage.setItem("companyId", response.data.companyId);
        // localStorage.setItem("company", this.roles[index].companyName);
      }
      if (this.$route.query.type == 2) {
        this.orderModel.receiverCompanyId = Number(localStorage.getItem("companyId"));
        this.orderModel.receiverName = localStorage.getItem("company");
        this.isRecivere = true;
        // localStorage.setItem("companyId", response.data.companyId);
        // localStorage.setItem("company", this.roles[index].companyName);
      }
      // console.log(this.isServer , "  . ",this.isRecivere);
    },

    created() {
      EventBus.$on("selectTreeNode", data => {
        data.type = "company";
        this.selectedCompany = data;
      });
    },

    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"]),
      mode() {
        return this.$route.query._mode;
      }
    },

    watch: {
      vsTableFeed(val) {
        this.refreshOrderProductsTable();
      }
    }
  };
</script>

<style scoped>
  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }

  .v-select .dropdown-toggle input {
    width: 100% !important;
  }

  .hover-pointer:hover {
    cursor: pointer;
  }
</style>
